import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {Routes, RouterModule} from "@angular/router";

import {MatDatepickerModule, MatInputModule} from "@angular/material";
import {NgbModalModule} from "@ng-bootstrap/ng-bootstrap";

import {HeaderComponent} from "./header/header.component";
// import { ShowErrorsComponent } from './show-errors/show-errors.component';
import {ReactiveFormsModule} from "@angular/forms";
import {OwlDateTimeModule, OwlNativeDateTimeModule} from "ng-pick-datetime";

import {AlertComponent} from "./alert/alert.component";
import {FooterComponent} from "./footer/footer.component";
import {AddLeadDialogComponent} from "./add-lead-dialog/add-lead-dialog.component";
import {AdminTabComponent} from "./admin-tab/admin-tab.component";
import {AddNewEventDialogComponent} from "./add-new-event-dialog/add-new-event-dialog.component";
import {AddFileDialogComponent} from "./add-file-dialog/add-file-dialog.component";
import {AddProjectDialogComponent} from "./add-project-dialog/add-project-dialog.component";

import {AddAppointmentDialogComponent} from "./add-appointment-dialog/add-appointment-dialog.component";
import {AddReminderDialogComponent} from "./add-reminder-dialog/add-reminder-dialog.component";
import {AddNoteDialogComponent} from "./add-note-dialog/add-note-dialog.component";
import {ProjectMapFilesDialogComponent} from "./project-map-files-dialog/project-map-files-dialog.component";
import {TabListComponent} from "./tab-list/tab-list.component";
import {EditReminderDialogComponent} from "./edit-reminder-dialog/edit-reminder-dialog.component";

@NgModule({
  declarations: [
    HeaderComponent,
    AlertComponent,
    FooterComponent,
    AddLeadDialogComponent,
    AdminTabComponent,
    AddNewEventDialogComponent,
    AddFileDialogComponent,
    AddProjectDialogComponent,
    AddAppointmentDialogComponent,
    AddReminderDialogComponent,
    AddNoteDialogComponent,
    ProjectMapFilesDialogComponent,
    TabListComponent,
    EditReminderDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatInputModule,
    MatDatepickerModule,
    NgbModalModule,
  ],
  exports: [
    HeaderComponent,
    AlertComponent,
    FooterComponent,
    AdminTabComponent,
    AddAppointmentDialogComponent,
    AddReminderDialogComponent,
    AddNoteDialogComponent,
    ProjectMapFilesDialogComponent,
    TabListComponent,
  ],
})
export class SharedModule {}
